/**
 * Согласование числительных.
 *
 * «3 мест» и «1 участников» человек читает как опечатку и переносит недоверие на
 * остальной текст экрана. Правило одно на всё приложение и лежит здесь, а не в вёрстке
 * каждой страницы: одни и те же слова встречаются на дне, в поиске, в форме брони
 * и в админке, и разъехавшееся согласование заметнее одной ошибки.
 */

/** Выбор формы по числу: 1 место, 2 места, 5 мест. */
export function plural(count: number, one: string, few: string, many: string): string {
  const mod100 = Math.abs(count) % 100
  const mod10 = mod100 % 10
  if (mod100 >= 11 && mod100 <= 14) return many
  if (mod10 === 1) return one
  if (mod10 >= 2 && mod10 <= 4) return few
  return many
}

/** «3 места» — вместимость переговорной. */
export function seats(count: number): string {
  return `${count} ${plural(count, 'место', 'места', 'мест')}`
}

/** «3 человека» — вместимость там, где говорят о людях, а не о стульях. */
export function people(count: number): string {
  return `${count} ${plural(count, 'человек', 'человека', 'человек')}`
}

/** «3 участника» — длина списка на встрече. */
export function participants(count: number): string {
  return `${count} ${plural(count, 'участник', 'участника', 'участников')}`
}

/** «12 минут» — длительность, посчитанная сервером и присланная числом. */
export function minutes(count: number): string {
  return `${count} ${plural(count, 'минуту', 'минуты', 'минут')}`
}

/** «3 встречи» — длина повторяющейся серии. */
export function meetings(count: number): string {
  return `${count} ${plural(count, 'встреча', 'встречи', 'встреч')}`
}

/**
 * Сказуемое при счётном подлежащем: «получит 1 человек», «получат 3 человека».
 *
 * Отдельной функцией, потому что согласовывать приходится не только существительное:
 * «Письмо об отмене получат 1 человек» ломается именно на глаголе, а сама фраза
 * с числом собрана правильно.
 */
export function receives(count: number): string {
  return plural(count, 'получит', 'получат', 'получат')
}

/** «3 приглашённых» — сводка формы брони. */
export function invited(count: number): string {
  return `${count} ${plural(count, 'приглашённый', 'приглашённых', 'приглашённых')}`
}
